import "../css/Header.css"
import * as React from "react";
import {
  AppBar, Box, Toolbar, Typography, IconButton, Drawer, List,
  Divider, ListItem, ListItemButton, ListItemText
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CancelIcon from "@mui/icons-material/Cancel";
import { Link } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import iconUser from "../img/icon_user.png";
import Logout from "./Logout";

/**
 * 管理者画面のヘッダ
 * @returns 
 */
function HeaderAdmin() {
  console.log("管理画面ヘッダ");

  const anchor = "left";
  const [state, setState] = React.useState({ left: false, });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      role="presentation"
      className="sideBar"
    >
      <List>
        {["海外の食品規則チェックサイト"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <IconButton className="cancelIcon" onClick={toggleDrawer(anchor, false)} size="large" edge="start" aria-label="menu" sx={{ mr: 2 }}>
                <CancelIcon />
              </IconButton>
              <ListItemText primary={text} primaryTypographyProps={{ variant: 'h6' }} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      {/* <List>
        {["検疫情報一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G010QuarantineList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider /> */}
      <List>
        {["輸出相手国"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0191ExportCountryList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["植物検疫"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0131PlantQuarantineList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["動物衛生・食品衛生／漁獲証明書"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0141AnimalQuarantineList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["放射線規制"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0151RadioActiveList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["残留農薬"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0201Rac"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["食品添加物"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0211FoodAdditive"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      {/* <List>
        {["紐づけマスタ管理"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G016LinkMaster"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider /> */}
      <List>
        {["入力ワード一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G017InputWord"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["更新履歴一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G011NewsList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      {/* ユーザは利用できないように修正2023/01/06 */}
      {/* <List>
        {["職員一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0181StaffList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider /> */}

      <List>
        {["初めての方へ"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0251FirstTimeList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["輸出要件・規制一覧"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0261RoadMapList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["よくあるご質問"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0221Question"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["利用規約・免責事項"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0231TermsServiceList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />

      <List>
        {["プライバシーポリシー"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton component={Link} to={"/G0241PrivacyPolicyList"} onClick={toggleDrawer(anchor, false)}>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
    </Box>
  );

  return (
    <div>
      <header className="header_pc">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" color="inherit">
            <Toolbar>
              <Box>
                <IconButton className="displayIcon" onClick={toggleDrawer(anchor, true)} size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
                  <MenuIcon />
                </IconButton>
                <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                  {list(anchor)}
                </Drawer>
              </Box>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                海外の食品規則チェックサイト　管理画面
              </Typography>
              <Typography className="userName" component="div" sx={{ flexGrow: 1 }}>
                <img className="iconUser" src={iconUser} />
                <Logout />
              </Typography>

            </Toolbar>
          </AppBar>
        </Box>
      </header>

      <header className="header_sp">
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="fixed" color="inherit">
            <Toolbar>
              <Box>
                <IconButton className="displayIcon" onClick={toggleDrawer(anchor, true)} size="large" edge="start" color="inherit" aria-label="menu"
                  sx={{ mr: 2, backgroundColor: "white" }}>
                  <MenuIcon />
                </IconButton>
                <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                  {list(anchor)}
                </Drawer>
              </Box>
              <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                海外の食品規則チェックサイト　管理画面
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
      </header>
    </div>
  );
}

export default HeaderAdmin;
